import React, { useState } from 'react'

const Title = ({ children }: { children: string }) => {
  const [isExpanded, setIsExpanded] = useState(false)

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded)
  }

  const baseStyle =
    'text-sm md:text-lg font-bold mb-4 cursor-pointer hover:text-bidfta-blue-light'
  const collapsedStyle = 'line-clamp-2'
  const expandedStyle = 'line-clamp-none'

  return (
    <h2
      className={`${baseStyle} ${isExpanded ? expandedStyle : collapsedStyle}`}
      onClick={toggleExpanded}
    >
      {children}
    </h2>
  )
}

export default Title
